module.exports = __webpack_public_path__ + "static/media/wind-turbine.a31f5f61.svg";